
import { RemoteDataVue } from "@/store/utils/remote-data";
import { Component } from "vue-property-decorator";

@Component
export default class Funnel extends RemoteDataVue {}
